export default (value: string): string => value.trim().replace(/(\W|_)/g, "");
